





















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import i18n from 'vue-i18n';
import EventBus from '@/eventBus';
import axios from 'axios';
import { get, uniq, map, uniqBy, upperFirst, toLower, cloneDeep } from 'lodash';
import { format, addHours } from 'date-fns';
import JSConfetti from 'js-confetti';
import CoImage from '@/components/Atoms/co-image/CoImage.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoAlert from '@/components/Molecules/co-alert/CoAlert.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoSkeleton from '@/components/Atoms/co-skeleton/CoSkeleton.vue';
import CoDate from '@/components/Molecules/co-date/CoDate.vue';
import CoPill from '@/components/Atoms/co-pill/CoPill.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoPeople from '@/components/Molecules/co-people/CoPeople.vue';
import CoLink from '@/components/Atoms/co-link/CoLink.vue';
import CoConfirmation from '@/components/Molecules/co-confirmation/CoConfirmation.vue';
import CoTippy from '@/components/Atoms/co-tippy/CoTippy.vue';
import CoDropdown from '@/components/Molecules/co-dropdown/CoDropdown.vue';
import CoDropdownItem from '@/components/Molecules/co-dropdown-item/CoDropdownItem.vue';
import CoDragDropFileUpload from '@/components/Organisms/co-drag-drop-file-upload/CoDragDropFileUpload.vue';
import CoLoadingIndicator from '@/components/Atoms/co-loading-indicator/coLoadingIndicator.vue';
import CoFormGroup from '@/components/Molecules/co-form-group/CoFormGroup.vue';
import CoInput from '@/components/Molecules/co-input/CoInput.vue';
import CoSelect from '@/components/Molecules/co-select/CoSelect.vue';
import CoCollapsible from '@/components/Molecules/co-collapsible/CoCollapsible.vue';
import CoIcon from '@/components/Atoms/co-icon/CoIcon.vue';
import CoModal from '@/components/Organisms/co-modal/CoModal.vue';
import CoContentSection from '@/components/Organisms/сo-content-section/CoContentSection.vue';
import { createAudioSection, getSectionKey } from '@/components/Organisms/сo-content-section/models';
import CoShare from '@/components/Organisms/co-share/CoShare.vue';
import { google, outlook, office365, yahoo, ics } from 'calendar-link';
import CoPostEditor from '@/components/Organisms/co-post-editor/coPostEditor.vue';
import CoMatch from '@/components/Molecules/co-match/CoMatch.vue';
import CoPost from '@/components/Organisms/co-post/CoPost.vue';
import CoEventTicketCheckout from '@/components/Organisms/co-event-ticket-checkout/CoEventTicketCheckout.vue';
import CoEventTicketCreateEdit from '@/components/Organisms/co-event-ticket-create-edit/CoEventTicketCreateEdit.vue';
import CoMyTicket from '@/components/Organisms/co-my-ticket/CoMyTicket.vue';
import CoStreamUpdatesIndicator from '@/components/Organisms/co-stream-updates-indicator/CoStreamUpdatesIndicator.vue';
import { SUPPORTED_IMAGE_ACCEPT } from '@/constants/fileUpload';
import CoUser from '@/components/Molecules/co-user/CoUser.vue';
import CoFile from '@/components/Organisms/CoFile/CoFile.vue';
import { AttachmentFile, normalizeAttachmentFile } from '@/utils/attachment';
import CoSwitch from '@/components/Atoms/co-switch/CoSwitch.vue';
import { isValidExternalUrl, normalizeUrlProtocol } from '@/utils/url';

const jsConfetti = new JSConfetti();
const EVENT_FEED_VISIBLE_BATCH_SIZE = 3;

type EventFeedEntry = {
    object: Record<string, any>;
    space?: Record<string, any>;
    wasUpdated?: boolean;
    streamUpdateHandled?: boolean;
    pendingStreamIndicatorEligible?: boolean;
};

export default {
    name: 'EventView',
    i18n: {
        messages: {
            en: {
                labels: {
                    seeattendees: 'See Attendees',
                    updateEvent: 'Update Event Details',
                    drafteventheadline: 'This event is in a draft mode',
                    eventVisability: 'Visibility',
                    publiceventheadline: 'This event is public and visible to everyone',
                    communityeventheadline: 'This event is visible to community members only',
                    draft: 'Draft',
                    public: 'Public',
                    communityOnly: 'Community Only',
                    closePreviewAsMember: 'Close Preview',
                    previewAsMember: 'Preview as Member',
                    addsection: 'Add Section',
                    textSection: 'Text Section',
                    imageSection: 'Image Section',
                    videoSection: 'Video Section',
                    audioSection: 'Podcast / Audio Section',
                    cancelattendance: 'Cancel attendance',
                    getticket: 'Get Ticket',
                    google: 'Google',
                    outlook: 'Outlook',
                    ics: 'ICS',
                    files: 'Files',
                    addFile: 'Add File',
                    dragdropimage: 'Drag an image here or click to select.',
                    suggestedsizes: 'Suggested size 1280x720px (16:9)',
                    savetocalendar: 'save to calendar',
                    posts: 'Posts',
                    andXMore: 'and {count} more',
                    manageparticipants: 'Manage Participants',
                    deleteEvent: 'Delete Event',
                },
                messages: {
                    cancelmessage: 'Are you sure about this? This event would be much nicer with you!',
                    createdthisevent: 'created this event',
                    makePublic: 'Event will be visible to everyone outside the community.',
                    communityOnly: 'Event will be visible only to community members.',
                    deleteImageHeaderWarning: 'Are you sure you want to delete the header image?',
                    draftEvent: 'Event will be saved as a draft making it hidden.',
                    eventdeleted: 'Event has been deleted.',
                    vieweventdetailsincommunity: 'View event',
                },
                eventPublishingMessages: {
                    public: 'This Event will be visible to everyone, also for people who are not members of your community. It appears under {publiceventslink}.',
                    draft: 'Event will be saved as a draft making it hidden.',
                    communityOnly: 'Event will be visible only to community members.',
                },
            },
            de: {
                labels: {
                    deleteEvent: 'Veranstaltung löschen',
                    seeattendees: 'Teilnehmer:innen anzeigen',
                    addaddress: 'Neue Adresse hinzufügen',
                    updateEvent: 'Veranstaltungsdetails aktualisieren',
                    drafteventheadline: 'Dieses Event ist im Entwurfsmodus',
                    eventVisability: 'Sichtbarkeit',
                    publiceventheadline: 'Dieses Event ist öffentlich und für alle sichtbar',
                    communityeventheadline: 'Dieses Event ist nur für Community-Mitglieder sichtbar',
                    draft: 'Entwurf',
                    public: 'Öffentlich',
                    communityOnly: 'Nur für die Community',
                    closePreviewAsMember: 'Vorschau schließen',
                    previewAsMember: 'Vorschau als Mitglied',
                    addsection: 'Abschnitt hinzufügen',
                    textSection: 'Textabschnitt',
                    imageSection: 'Bildabschnitt',
                    videoSection: 'Videoabschnitt',
                    audioSection: 'Podcast-/Audioabschnitt',
                    cancelattendance: 'Teilnahme absagen',
                    getticket: 'Tickets',
                    files: 'Dateien',
                    addFile: 'Datei hinzufügen',
                    dragdropimage: 'Ziehe ein Bild hierher oder klicke zum Auswählen',
                    suggestedsizes: 'Empfohlene Größe 1280x720px (16:9)',
                    savetocalendar: 'im Kalender speichern',
                    posts: 'Beiträge',
                    andXMore: 'und {count} weitere',
                    manageparticipants: 'Teilnehmende verwalten',
                },
                messages: {
                    cancelmessage:
                        'Bist du dir sicher, dass du das willst? Diese @:labels.event wäre viel schöner mit dir!',
                    createdthisevent: 'hat diese Veranstaltung erstellt',
                    makePublic: 'Die Veranstaltung wird für alle außerhalb der Community sichtbar.',
                    communityOnly: 'Die Veranstaltung wird nur für Community-Mitglieder sichtbar.',
                    deleteImageHeaderWarning: 'Möchtest du das Titelbild wirklich löschen?',
                    draftEvent: 'Die Veranstaltung wird als Entwurf gespeichert und versteckt.',
                    eventdeleted: 'Die Veranstaltung wurde gelöscht.',
                    vieweventdetailsincommunity: 'Veranstaltung anzeigen',
                },
                eventPublishingMessages: {
                    public: 'Diese Veranstaltung wird für alle sichtbar, auch für Personen, die nicht Mitglied deiner Community sind. Sie erscheint unter {publiceventslink}.',
                    draft: 'Die Veranstaltung wird als Entwurf gespeichert und versteckt.',
                    communityOnly: 'Die Veranstaltung wird nur für Community-Mitglieder sichtbar.',
                },
            },
        },
    },
    components: {
        CoAlert,
        CoPost,
        CoPostEditor,
        CoStreamUpdatesIndicator,
        CoIcon,
        CoImage,
        CoText,
        CoButton,
        CoRoundButton,
        CoHeadline,
        CoDate,
        CoPill,
        CoCard,
        CoPeople,
        CoLink,
        CoTippy,
        CoSkeleton,
        CoConfirmation,
        CoDropdown,
        CoDropdownItem,
        CoDragDropFileUpload,
        CoLoadingIndicator,
        CoFormGroup,
        CoInput,
        CoSelect,
        CoCollapsible,
        CoContentSection,
        CoModal,
        CoShare,
        CoMatch,
        CoEventTicketCheckout,
        CoEventTicketCreateEdit,
        CoMyTicket,
        CoUser,
        CoSwitch,
        CoFile,
    },
    props: {
        slug: {
            type: String,
            required: false,
            default: 'test',
        },
        me: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        isPaymentsEnabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            newImage: null,
            newImageUploading: false,
            imageAccept: SUPPORTED_IMAGE_ACCEPT,
            event: {},
            createdBy: {},
            preview: false,

            todayDate: new Date().toISOString().split('T')[0],
            startDate: '',
            startTime: '',

            endDate: '',
            endTime: '',

            loadingParticipants: false,
            participants: [],

            sectionsRerenderKey: 0,

            feed: [],
            feedBank: [],
            loadingUpdates: false,
            updatesNextPage: '',

            coOrganizersCandidates: [],
            loadingEvent: false,
            loading: false,

            types: [],
            selectedType: null,
            locations: [],
            selectedLocation: null,
            customLocation: {
                Name: '',
                Address: '',
                ZipCode: '',
                City: '',
                Country: '',
            },
            tags: [],

            taxRates: [],
            loadingTaxRates: false,
            ticketsLoading: false,

            myTickets: null,
            loadingMyTicket: false,

            ticketPurchaseState: '',
            ticketPurchaseTicketID: '',
            ticketingMode: 'rsvp',
            eventFormatMode: 'physical',
            rerenderTickets: 0,
            pendingEventAttachments: [] as Array<AttachmentFile & { __tempID?: string }>,
            attachmentUploadCounter: 0,

            toToogleShareInFeed: false,
            pendingStreamPostIDs: [] as string[],
            pendingStreamPostIcon: 'chevron-up',
            eventFeedRecoveryEventID: null as string | null,
        };
    },
    watch: {
        startDate(val) {
            // if end date is before start date, set end date to start date

            // convert to timestamp
            const start = new Date(val);
            const end = new Date(this.endDate);

            if (end < start) {
                this.endDate = val;
            }
        },

        startTime(val) {
            // if end time is before start time, set end time to start time
            // compose start date and time
            const start = new Date(`${this.startDate}T${this.startTime}`);
            const end = new Date(`${this.endDate}T${this.endTime}`);
            // convert to timestamp

            if (end <= start) {
                const tmp = addHours(start, 1);
                this.endTime = format(tmp, 'HH:mm');
            }
        },
        types(val) {
            if (this.event.EventType && this.event.EventType.length > 0 && val) {
                this.selectedType = val.find((t) => t.Value === this.event.EventType[0]);
            }
        },

        locations(val) {
            if (this.event.Location && val) {
                this.selectedLocation = val.find((t) => t.Value === this.event.Location);
                if (!this.selectedLocation && this.event.Location) {
                    this.selectedLocation = {
                        Name: this.event.Location,
                        Value: this.event.Location,
                        Disabled: false,
                    };
                }
            }
        },
        canGetUpdates(val) {
            if (val) {
                this.getEventFeed();
                this.subscribeToEventFeedMessages();
                return;
            }

            this.unsubscribeFromEventFeedMessages();
        },
        'event.ID': {
            handler(eventID, previousEventID) {
                if (previousEventID) {
                    EventBus.$off(`POST_CREATE_1_${previousEventID}`, this.handleRealtimePostCreated);
                }
                this.pendingStreamPostIDs = [];
                if (eventID && this.canGetUpdates) this.subscribeToEventFeedMessages();
            },
        },
    },
    computed: {
        feedIndexByID() {
            const indexByID: Record<string, number> = {};
            this.feed.forEach((entry, index) => {
                const postID = get(entry, 'object.ID', '').toString();
                if (postID) indexByID[postID] = index;
            });
            return indexByID;
        },
        locationsForSelect() {
            let locationsList = [];

            if (this.event.Location) {
                locationsList.push({
                    Name: this.event.Location,
                    Value: this.event.Location,
                    Disabled: false,
                });
            }

            locationsList = locationsList.concat(
                this.locations.map((location) => ({
                    Name: location.Address ? `${location.Name}, ${location.Address}` : location.Name,
                    Value: location.Address ? `${location.Name}, ${location.Address}` : location.Name,
                    Disabled: false,
                    Address: location.Address ? location.Address : '',
                }))
            );

            locationsList = uniqBy(locationsList, 'Name');
            // if no custom location in list then
            // add custom location
            if (!locationsList.find((l) => l.Value === 'custom')) {
                locationsList.push({
                    Name: this.$t('labels.addaddress'),
                    Value: 'custom',
                    Disabled: false,
                });
            }

            return locationsList;
        },
        // useTicketCheckout check if there any active ticket in even
        useTicketCheckout() {
            const tickets = this.event?.Tickets || [];
            return tickets.some((ticket) => !ticket.Deleted);
        },
        hasExistingTickets() {
            return this.useTicketCheckout;
        },
        hidePurchaseButton() {
            if (this.useTicketCheckout) {
                return false;
            }
            return true;
        },
        ticketColumns() {
            if (this.$isMobile) {
                return [
                    { key: 'Name', title: this.$t('labels.name') },
                    { key: 'Sold', title: this.$t('labels.sold') },
                    { key: 'actions', title: '', class: 'text-right' },
                ];
            }

            return [
                { key: 'Name', title: this.$t('labels.name') },
                { key: 'price', title: this.$t('labels.price') },
                { key: 'VAT', title: this.$t('labels.vat') },
                { key: 'Status', title: this.$t('labels.status') },
                { key: 'Sold', title: this.$t('labels.sold') },
                { key: 'actions', title: '', class: 'text-right' },
            ];
        },
        noContent() // if no sections and no image and no tags return true
        {
            return (
                (!this.event.Sections || this.event.Sections.length === 0) &&
                !this.event.ImageURL &&
                (!this.event.Tags || this.event.Tags.length === 0) &&
                (!this.feed || this.feed.length === 0)
            );
        },
        eventurl() {
            return `${window.location.origin}/events/${this.event.Slug}`;
        },
        isEventPast() {
            return this.event.EndDate < new Date().getTime() / 1000;
        },
        // participantsToDisplay returns list of participants to display sorted by role (creator, organizers, participants) but if user status is -1 or no name are excluded from the list, and all accounts without image are moved to the end of the list.
        participantsToDisplay() {
            if (!this.participants || this.participants.length === 0) {
                return [];
            }

            const participants = this.participants.filter((p) => p.Status !== -1 && p.Name);

            // sort by image presence first (with image first), then by role priority (creator, organizer, others)
            participants.sort((a, b) => {
                const aHasImage = !!a.ImageURL;
                const bHasImage = !!b.ImageURL;

                if (aHasImage && !bHasImage) {
                    return -1;
                }
                if (!aHasImage && bHasImage) {
                    return 1;
                }

                const rolePriority = (role) => {
                    if (role === 'creator') {
                        return 0;
                    }
                    if (role === 'organizer') {
                        return 1;
                    }
                    return 2;
                };

                const aPriority = rolePriority(a.Role);
                const bPriority = rolePriority(b.Role);

                if (aPriority < bPriority) {
                    return -1;
                }
                if (aPriority > bPriority) {
                    return 1;
                }
                return 0;
            });

            return participants;
        },

        allParticipants() {
            const p = get(this.event, 'Participants', []);
            const o = get(this.event, 'Organizers', []);
            // concat participants and organizers and remove duplicates
            let res = [...p, ...o];
            // add createdBy
            res = res.concat(this.event.CreatedBy);

            return uniq(res);
        },
        // otherParticipantsCount returns number of participants excluding participantsToDisplay
        otherParticipantsCount() {
            if (!this.allParticipants || this.allParticipants.length === 0) {
                return 0;
            }

            if (!this.participantsToDisplay || this.participantsToDisplay.length === 0) {
                return this.allParticipants.length;
            }

            return this.allParticipants.length - this.participantsToDisplay.length;
        },

        hasParticipants() {
            const participantsCount = get(this.event, 'ParticipantsCount', null);
            if (typeof participantsCount === 'number') {
                return participantsCount > 0;
            }
            const participants = get(this.event, 'Participants', []);
            return participants.length > 0;
        },
        shouldShowParticipantMatch() {
            if (!this.$store || !this.$store.state || !this.$store.state.space) {
                return false;
            }

            return !this.$store.state.space.MatchingOff;
        },
        canIEditIgnorePreview() {
            return (this.amIorganising || this.amIAdmin) && this.event.SpaceID === this.me.SpaceID;
        },
        canIEdit() {
            return (this.amIorganising || this.amIAdmin) && !this.preview && this.event.SpaceID === this.me.SpaceID;
        },
        amIattending() {
            return this.event.Participants && this.event.Participants.some((p) => p === this.me.ID);
        },
        amIorganising() {
            return this.event?.CreatedBy === this.me.ID || this.event?.Organizers?.some((o) => o === this.me.ID);
        },
        amIAdmin() {
            return get(this.me, 'Permissions', '').includes('space_admin');
        },
        canGetUpdates() {
            return Boolean(this.event?.ID && (this.amIattending || this.amIorganising || this.amIAdmin));
        },
        eventFormatModeHybrid() {
            return this.eventFormatMode === 'hybrid';
        },
        eventFormatModeOnline() {
            return this.eventFormatMode === 'online';
        },
        eventFormatModePhysical() {
            return this.eventFormatMode === 'physical';
        },
        ticketingModeExternal() {
            return this.ticketingMode === 'external';
        },
        ticketingModeInternal() {
            return this.ticketingMode === 'internal';
        },
        ticketingModeRsvp() {
            return this.ticketingMode === 'rsvp';
        },
        isCircleEvent() {
            return this.event?.SpaceID && this.me?.SpaceID && this.event?.SpaceID !== this.me?.SpaceID;
        },
        isSameDay() {
            const start = new Date(this.event.StartDate * 1000);
            const end = new Date(this.event.EndDate * 1000);
            return start.toDateString() === end.toDateString();
        },
        loactionWithNewLine() {
            if (!this.event || !this.event.Location) {
                return '';
            }
            return this.event.Location.replaceAll(', ', '<br/>');
        },
        eventAttachments() {
            const attachments = get(this.event, 'Attachments', []);
            if (!attachments || attachments.length === 0) {
                return [];
            }
            return attachments.map((attachment) => normalizeAttachmentFile(attachment));
        },
        attachmentsLimit() {
            return 5;
        },
        attachmentsForDisplay() {
            if (this.eventAttachments.length <= this.attachmentsLimit) {
                return this.eventAttachments;
            }
            return this.eventAttachments.slice(0, this.attachmentsLimit);
        },
        shouldShowAttachmentsSection() {
            return this.canIEdit || this.eventAttachments.length > 0 || this.pendingEventAttachments.length > 0;
        },
        eventCreator() {
            if (this.event.CreatedBy && this.participants?.length > 0) {
                return this.participants.filter((i) => i.ID === this.event.CreatedBy)[0];
            }
            return {};
        },
        canIPost() {
            return this.amIorganising;
        },
        canCreateFeedPost() {
            return this.$store.state.permissions && this.$store.state.permissions['feed.post'] === true;
        },
    },
    created() {
        window.addEventListener('scroll', this.scroll);
        window.addEventListener('scroll', this.handlePendingStreamPostScroll, { passive: true });
        this.getEvent();
        this.getTaxRates();
    },
    mounted() {
        EventBus.$on('REALTIME_STREAM_RECONNECTED', this.handleRealtimeStreamReconnected);
        if (this.$route.query.tp) {
            this.ticketPurchaseState = this.$route.query.tp;
            this.ticketPurchaseTicketID = this.$route.query.ticket_type_id;
            // remove tp and ticket_type_id from query params
            this.$router.replace({
                query: {
                    ...this.$route.query,
                    tp: undefined,
                    ticket_type_id: undefined,
                },
            });

            if (this.useTicketCheckout && this.ticketPurchaseState === 'buy') {
                this.startTicketPurchaseFlow();
            }

            if (this.ticketPurchaseState === 'success') {
                this.maybeHandleTicketPurchaseSuccess();
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handlePendingStreamPostScroll);
        window.removeEventListener('scroll', this.scroll);
        EventBus.$off('REALTIME_STREAM_RECONNECTED', this.handleRealtimeStreamReconnected);
        this.unsubscribeFromEventFeedMessages();
    },

    methods: {
        getSectionKey,
        subscribeToEventFeedMessages() {
            if (!this.canGetUpdates || !this.event?.ID) return;
            EventBus.$off(`POST_CREATE_1_${this.event.ID}`, this.handleRealtimePostCreated);
            EventBus.$on(`POST_CREATE_1_${this.event.ID}`, this.handleRealtimePostCreated);
        },
        unsubscribeFromEventFeedMessages() {
            if (!this.event?.ID) return;
            EventBus.$off(`POST_CREATE_1_${this.event.ID}`, this.handleRealtimePostCreated);
        },
        async handleRealtimePostCreated(post) {
            try {
                if (
                    !post ||
                    typeof post !== 'object' ||
                    String(post.ParentID) !== String(this.event?.ID) ||
                    !this.canGetUpdates
                ) {
                    return;
                }

                const normalizedEntry = { object: cloneDeep(post) } as EventFeedEntry;
                if (!normalizedEntry.object || typeof normalizedEntry.object !== 'object') {
                    return;
                }
                if (!normalizedEntry.space && this.event?.Space) {
                    normalizedEntry.space = this.event.Space;
                }

                normalizedEntry.object.CreatedAt = normalizedEntry.object.CreatedAt || normalizedEntry.object.Created;
                normalizedEntry.object.UpdatedAt = normalizedEntry.object.UpdatedAt || normalizedEntry.object.Updated;

                if (!normalizedEntry.object.Author && normalizedEntry.object.AuthorID) {
                    const existingFeedEntry = [...this.feed, ...this.feedBank].find(
                        (entry) => get(entry, 'object.AuthorID') === normalizedEntry.object.AuthorID
                    );
                    if (existingFeedEntry) {
                        normalizedEntry.object.Author = get(existingFeedEntry, 'object.Author', null);
                    } else {
                        // Keep the first streamed post render-safe even when the feed started empty.
                        const [author] = await this.fetchFeedAuthors([normalizedEntry.object.AuthorID]);
                        if (author) {
                            normalizedEntry.object.Author = author;
                        }
                    }
                }
                if (String(post.ParentID) !== String(this.event?.ID)) return;

                const images = get(normalizedEntry, 'object.Images', null);
                normalizedEntry.object.Images = map(images, (image) =>
                    typeof image === 'string'
                        ? { ImageURL: image }
                        : { ...image, ImageURL: image.ImageURL || image.url }
                );

                const entryID = get(normalizedEntry, 'object.ID', '').toString();
                if (!entryID) {
                    return;
                }

                const existingFeedIndex = this.feed.findIndex(
                    (entry) => get(entry, 'object.ID', '').toString() === entryID
                );
                const existingFeedBankIndex = this.feedBank.findIndex(
                    (entry) => get(entry, 'object.ID', '').toString() === entryID
                );

                if (existingFeedIndex > -1) {
                    this.feed.splice(existingFeedIndex, 1, {
                        ...normalizedEntry,
                        wasUpdated: this.feed[existingFeedIndex]?.wasUpdated || false,
                        streamUpdateHandled: this.feed[existingFeedIndex]?.streamUpdateHandled || false,
                        pendingStreamIndicatorEligible:
                            this.feed[existingFeedIndex]?.pendingStreamIndicatorEligible || false,
                    });
                } else if (existingFeedBankIndex > -1) {
                    this.feedBank.splice(existingFeedBankIndex, 1, normalizedEntry);
                } else {
                    normalizedEntry.wasUpdated = true;
                    normalizedEntry.streamUpdateHandled = false;
                    // Only posts received through the shared realtime stream should increment the pending indicator.
                    normalizedEntry.pendingStreamIndicatorEligible = true;
                    this.feed.push(normalizedEntry);
                    // App owns the browser-title indicator shared by all realtime feeds.
                    EventBus.$emit('TAB_ATTENTION');
                }

                this.feed = this.feed
                    .filter(Boolean)
                    .sort(
                        (a, b) =>
                            Number(get(b, 'object.CreatedAt', get(b, 'object.Created', 0))) -
                            Number(get(a, 'object.CreatedAt', get(a, 'object.Created', 0)))
                    )
                    .filter(
                        (entry, index, entries) =>
                            index ===
                            entries.findIndex(
                                (candidate) =>
                                    get(candidate, 'object.ID', '').toString() ===
                                    get(entry, 'object.ID', '').toString()
                            )
                    );
            } catch (error) {
                console.error('Failed to process realtime event post_create message', error);
            }
        },
        async handleRealtimeStreamReconnected() {
            const eventID = this.event?.ID?.toString();
            if (this.eventFeedRecoveryEventID === eventID || !eventID || !this.canGetUpdates) return;

            this.eventFeedRecoveryEventID = eventID;
            try {
                await this.refreshFeedAfterRealtimeStreamConnected();
            } catch (error) {
                console.error('Failed to refresh event feed after realtime stream reconnect', error);
            } finally {
                // Do not clear a newer event's recovery when navigation happened during this request.
                if (this.eventFeedRecoveryEventID === eventID) this.eventFeedRecoveryEventID = null;
            }
        },
        async refreshFeedAfterRealtimeStreamConnected() {
            const eventID = this.event?.ID;
            if (!eventID || !this.canGetUpdates) return;

            const response = await axios({
                method: 'GET',
                url: `/event/feed/${eventID}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (String(eventID) !== String(this.event?.ID) || !this.canGetUpdates) return;

            const feedObjects =
                get(response, 'data.objects', null) || (Array.isArray(response?.data) ? response.data : null) || [];
            if (!Array.isArray(feedObjects) || feedObjects.length === 0) {
                return;
            }

            let feedEntries = feedObjects.map((entry) =>
                get(entry, 'object') ? cloneDeep(entry) : { object: cloneDeep(entry) }
            );
            const authorIDs = uniq(feedEntries.map((entry) => get(entry, 'object.AuthorID')).filter(Boolean));
            let users = [];

            if (authorIDs.length > 0) {
                try {
                    const usersResponse = await axios({
                        method: 'POST',
                        url: '/user/listbyids',
                        data: { IDS: map(authorIDs, (id) => ({ ID: id })) },
                        withCredentials: true,
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    });

                    users = map(get(usersResponse, 'data.Users', []), (user) => ({
                        ID: get(user, 'ID'),
                        Name: get(user, 'Profile.Name'),
                        Slug: get(user, 'Slug'),
                        ImageURL: get(user, 'Profile.ImageURL'),
                        Bio: get(user, 'Profile.Bio'),
                    }));
                } catch (error) {
                    // Feed recovery still succeeds when an author lookup is temporarily unavailable.
                    console.error('Failed to load recovered event post authors', error);
                }
            }
            if (String(eventID) !== String(this.event?.ID) || !this.canGetUpdates) return;

            feedEntries = feedEntries.map((entry) => {
                if (!entry.object || typeof entry.object !== 'object') {
                    return entry;
                }

                const normalizedEntry = {
                    ...entry,
                    space: entry.space || this.event?.Space,
                    object: {
                        ...entry.object,
                    },
                };

                normalizedEntry.object.CreatedAt = normalizedEntry.object.CreatedAt || normalizedEntry.object.Created;
                normalizedEntry.object.UpdatedAt = normalizedEntry.object.UpdatedAt || normalizedEntry.object.Updated;

                if (!normalizedEntry.object.Author && users.length > 0) {
                    normalizedEntry.object.Author = users.find(
                        (user) => user.ID === get(normalizedEntry, 'object.AuthorID')
                    );
                }

                const images = get(normalizedEntry, 'object.Images', get(normalizedEntry, 'object.ImageURLs', []));
                normalizedEntry.object.Images = map(images, (image) =>
                    image?.ImageURL ? image : { ...image, ImageURL: image?.url || image }
                );

                return normalizedEntry;
            });

            const incomingEntryIDs = feedEntries.map((entry) => get(entry, 'object.ID', '').toString()).filter(Boolean);
            const knownEntryIDs = new Set(
                [...this.feed, ...this.feedBank].map((entry) => get(entry, 'object.ID', '').toString()).filter(Boolean)
            );
            const hasNewTopPosts = incomingEntryIDs.some((entryID) => !knownEntryIDs.has(entryID));

            if (!hasNewTopPosts) {
                return;
            }

            feedEntries.forEach((entry) => {
                const entryID = get(entry, 'object.ID', '').toString();
                if (!entryID) {
                    return;
                }

                const existingFeedIndex = this.feed.findIndex(
                    (feedEntry) => get(feedEntry, 'object.ID', '').toString() === entryID
                );
                const existingFeedBankIndex = this.feedBank.findIndex(
                    (feedEntry) => get(feedEntry, 'object.ID', '').toString() === entryID
                );

                if (existingFeedIndex > -1) {
                    this.feed.splice(existingFeedIndex, 1, {
                        ...entry,
                        wasUpdated: this.feed[existingFeedIndex]?.wasUpdated || false,
                        streamUpdateHandled: this.feed[existingFeedIndex]?.streamUpdateHandled || false,
                        pendingStreamIndicatorEligible:
                            this.feed[existingFeedIndex]?.pendingStreamIndicatorEligible || false,
                    });
                    return;
                }

                if (existingFeedBankIndex > -1) {
                    this.feedBank.splice(existingFeedBankIndex, 1, entry);
                    return;
                }

                this.feed.push({
                    ...entry,
                    wasUpdated: true,
                    streamUpdateHandled: false,
                });
            });

            this.feed = this.feed
                .filter(Boolean)
                .sort(
                    (a, b) =>
                        Number(get(b, 'object.CreatedAt', get(b, 'object.Created', 0))) -
                        Number(get(a, 'object.CreatedAt', get(a, 'object.Created', 0)))
                )
                .filter(
                    (entry, index, entries) =>
                        index ===
                        entries.findIndex(
                            (candidate) =>
                                get(candidate, 'object.ID', '').toString() === get(entry, 'object.ID', '').toString()
                        )
                );
        },
        handleStreamPostUpdated(post) {
            if (post.streamUpdateHandled) {
                return;
            }

            // Mark each update as handled once; only shared realtime inserts should reach the pending indicator.
            this.$set(post, 'streamUpdateHandled', true);
            if (!post.pendingStreamIndicatorEligible) {
                return;
            }

            this.$set(post, 'pendingStreamIndicatorEligible', false);
            const postID = get(post, 'object.ID', '').toString();
            if (!postID || this.pendingStreamPostIDs.includes(postID) || this.isStreamPostVisible(postID)) {
                return;
            }

            // Leave the highlight off until the member explicitly reveals the streamed post.
            this.$set(post, 'wasUpdated', false);
            this.pendingStreamPostIDs.push(postID);
            this.updatePendingStreamPostIcon();
        },
        isStreamPostVisible(postID: string) {
            const refEl = this.$refs[`post${postID}`];
            const postComponent = Array.isArray(refEl) ? refEl[0] : refEl;
            const postElement = postComponent?.$el || postComponent;
            if (!postElement?.getBoundingClientRect) {
                return false;
            }

            const { top, bottom } = postElement.getBoundingClientRect();
            return top < window.innerHeight && bottom > 0;
        },
        handlePendingStreamPostScroll() {
            const visiblePostID = this.pendingStreamPostIDs.find((postID) => this.isStreamPostVisible(postID));
            if (!visiblePostID) {
                this.updatePendingStreamPostIcon();
                return;
            }

            const visiblePost = this.feed[this.feedIndexByID[visiblePostID]];
            if (visiblePost) {
                this.$set(visiblePost, 'wasUpdated', true);
            }
            this.removePendingStreamPostID(visiblePostID);
        },
        updatePendingStreamPostIcon() {
            const targetPost = this.feed.find((entry) =>
                this.pendingStreamPostIDs.includes(get(entry, 'object.ID', '').toString())
            );
            const targetPostID = get(targetPost, 'object.ID', '').toString();
            if (!targetPostID) {
                return;
            }

            const refEl = this.$refs[`post${targetPostID}`];
            const postComponent = Array.isArray(refEl) ? refEl[0] : refEl;
            const postElement = postComponent?.$el || postComponent;
            if (!postElement?.getBoundingClientRect) {
                return;
            }

            this.pendingStreamPostIcon =
                postElement.getBoundingClientRect().top > window.innerHeight ? 'chevron-down' : 'chevron-up';
        },
        removePendingStreamPostID(postID: string | number = '') {
            const normalizedPostID = postID ? postID.toString() : '';
            if (!normalizedPostID) {
                return;
            }

            this.pendingStreamPostIDs = this.pendingStreamPostIDs.filter((id) => id !== normalizedPostID);
            this.$nextTick(() => this.updatePendingStreamPostIcon());
        },
        scrollToPendingStreamPost() {
            const targetPost = this.feed.find((entry) =>
                this.pendingStreamPostIDs.includes(get(entry, 'object.ID', '').toString())
            );
            const targetPostID = get(targetPost, 'object.ID');

            if (!targetPostID) {
                this.pendingStreamPostIDs = [];
                return;
            }

            // Re-enable the streamed-post highlight when navigation lands on the target post.
            this.$set(targetPost, 'wasUpdated', true);
            this.$nextTick(() => {
                const refEl = this.$refs[`post${targetPostID}`];
                const postComponent = Array.isArray(refEl) ? refEl[0] : refEl;
                const postElement = postComponent?.$el || postComponent;
                if (postElement?.scrollIntoView) {
                    postElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                this.removePendingStreamPostID(targetPostID);
            });
        },
        syncFeedOrder() {
            this.feed = this.feed
                .filter(Boolean)
                .sort(
                    (a, b) =>
                        Number(get(b, 'object.CreatedAt', get(b, 'object.Created', 0))) -
                        Number(get(a, 'object.CreatedAt', get(a, 'object.Created', 0)))
                )
                .filter(
                    (entry, index, entries) =>
                        index ===
                        entries.findIndex(
                            (candidate) =>
                                get(candidate, 'object.ID', '').toString() === get(entry, 'object.ID', '').toString()
                        )
                );
        },
        maybeHandleTicketPurchaseSuccess() {
            if (this.ticketPurchaseState !== 'success') {
                return;
            }
            if (!this.event || !this.event.ID) {
                return;
            }
            this.ticketPurchaseSuccess();
        },
        ticketPurchaseSuccess() {
            this.ticketPurchaseState = '';
            jsConfetti.addConfetti();
            EventBus.$emit('INFO', {
                Message: this.$t('messages.event.ticketPurchaseSuccess'),
                Details: '',
            });

            // Avoid triggering a nested/overlapping getEvent() call while an event fetch is already in progress.
            if (!this.loadingEvent) {
                this.getEvent();
            }
        },
        startTicketPurchaseFlow() {
            if (this.isEventPast) {
                return;
            }
            this.$refs.ticketscheckout.openModal();
        },

        setPrefilledContentForSharingInFeed() {
            if (!this.canCreateFeedPost) return;
            // if feature flag for new post in pages is on
            const cfg = {
                Type: 'post',
                ParentID: this.event.ID,
                ParentType: 1,
                FeatureContentID: this.event.ID, // this page is the featured content and parent
                FeaturedContentType: 1,
                FeedDisplay: 2, // show in event feed and community feed
                LockParentDestination: false,
                LockFeedDestination: true,
                DisablePageSearch: true,
                Title: this.event.Title,
                ImageURL: this.event.ImageURL,
            };

            if (!this.canIPost) {
                cfg.ParentID = '';
                cfg.ParentType = 0;
                cfg.FeedDisplay = 0;
                cfg.LockFeedDestination = true;
                cfg.LockParentDestination = true;
            }

            EventBus.$emit('STARTNEWPOST', {
                cfg,
            });
        },
        setPreFilledContentForPostingUpdate() {
            this.$refs.posteditor.show({
                Type: 'post',
                ParentID: this.event.ID,
                ParentType: 1,
                FeedDisplay: 1, // show in event feed only
                LockParentDestination: true,
                LockFeedDestination: true,
                Title: this.event.Title,
                ImageURL: this.event.ImageURL,
            });
        },
        ticketRefunded() {
            EventBus.$emit('INFO', {
                Message: this.$t('messages.event.ticketRefundSuccess'),
                Details: '',
            });

            this.getEvent();
        },

        ticketRefundFailed() {
            EventBus.$emit('ERROR', {
                Message: this.$t('messages.event.ticketRefundError'),
                Details: '',
            });
        },

        getMyTicket() {
            this.loadingMyTicket = true;
            axios
                .get(`/event/ticket/list-my/for-event-id/${this.event.ID}`)
                .then((response) => {
                    this.myTickets = get(response, 'data.tickets', null);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    this.loadingMyTicket = false;
                });
        },

        archiveTicket(ticket) {
            this.ticketsLoading = true;
            ticket.Deleted = true;
            this.updateEventTicket(ticket);
        },
        unarchiveTicket(ticket) {
            this.ticketsLoading = true;
            ticket.Deleted = false;
            this.updateEventTicket(ticket);
        },
        updateEventTicket(newTicket) {
            // replace ticket in event.Tickets with new ticket by ID
            this.event.Tickets = this.event.Tickets.map((ticket) => {
                if (ticket.ID === newTicket.ID) {
                    return newTicket;
                }
                return ticket;
            });

            this.ticketsLoading = true;
            this.ticketsLoading = false;
            this.rerenderTickets += 1;
        },
        createEventTicket(ticket) {
            this.ticketsLoading = true;
            // Replace the state so Vue 2 observes Tickets even if the API omitted it or it was added non-reactively.
            this.event = { ...this.event, Tickets: [...(this.event.Tickets || []), ticket] };
            this.ticketsLoading = false;
            this.rerenderTickets += 1;
        },

        getTaxRateForTicket(ticket) {
            const taxrate = this.taxRates.find((taxrate) => taxrate.ID === ticket.TaxRateID);

            if (!taxrate) {
                return '-';
            }

            if (!taxrate.Percentage) {
                return '0%';
            }

            return `${taxrate.Percentage}%`;
        },

        addToCalendar(cal = 'google') {
            const calendarEvent = {
                richText: {
                    title: this.event.Title,
                    location: this.event.Location ? this.event.Location : null,
                    description: this.convertToPlain(this.event.Description),
                    start: new Date(this.event.StartDate * 1000).toISOString(),
                    end: new Date(this.event.EndDate * 1000).toISOString(),
                },
                plainText: {
                    title: this.event.Title,
                    location: this.event.Location ? this.event.Location.replaceAll(',', '\\,') : null,
                    description: this.convertToPlain(this.event.Description),
                    start: new Date(this.event.StartDate * 1000).toISOString(),
                    end: new Date(this.event.EndDate * 1000).toISOString(),
                },
            };
            // add event url to the description
            if (this.eventurl) {
                calendarEvent.richText.description += `<hr />🔗 <a href="${this.eventurl}" target="_blank">${this.$t(
                    'messages.vieweventdetailsincommunity'
                )}</a>`;
                calendarEvent.plainText.description += `
                ----------------
                🔗 ${this.$t('messages.vieweventdetailsincommunity')}: ${this.eventurl}`;
            }
            // Then fetch the link
            if (cal === 'google') {
                const calendarUrl = google(calendarEvent.richText);
                if (this.$store?.state?.isInMobile) {
                    this.openCalendarInBrowser(calendarUrl);
                    return;
                }
                window.open(calendarUrl, '_blank');
            } else if (cal === 'outlook') {
                const calendarUrl = outlook(calendarEvent.richText);
                if (this.$store?.state?.isInMobile) {
                    this.openCalendarInBrowser(calendarUrl);
                    return;
                }
                window.open(calendarUrl, '_blank');
            } else if (cal === 'ics') {
                if (this.$route?.query?.downloadics) {
                    // remove downloadics from query params
                    this.$router.replace({
                        query: {
                            ...this.$route.query,
                            downloadics: undefined,
                        },
                    });
                    // The mobile app has opened this page in a browser, where the file can now be downloaded.
                    this.downloadIcsFile(calendarEvent.plainText);
                    // close the browser tab after a short delay
                    setTimeout(() => {
                        window.close();
                    }, 1000);
                    return;
                }
                // if in mobile in app, open current host in new browser tab with downloadics param set to true
                if (this.$store?.state?.isInMobile) {
                    this.openCalendarInBrowser(`/events/${this.event.Slug}?downloadics=true`);
                    return;
                }
                this.downloadIcsFile(calendarEvent.plainText);
            }
        },
        downloadIcsFile(calendarEvent) {
            // Download a real calendar file because browsers block top-level navigation to data URLs.
            const calendarDataUrl = ics(calendarEvent);
            const calendarContent = decodeURIComponent(calendarDataUrl.slice(calendarDataUrl.indexOf(',') + 1));
            const objectUrl = window.URL.createObjectURL(
                new Blob([calendarContent], { type: 'text/calendar;charset=utf-8' })
            );
            const link = document.createElement('a');
            link.href = objectUrl;
            link.setAttribute('download', `${this.event.Slug || 'event'}.ics`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setTimeout(() => window.URL.revokeObjectURL(objectUrl), 0);
        },
        openCalendarInBrowser(calendarUrl) {
            // The native app observes this query parameter and opens the external URL in the device browser.
            this.$router.push({
                query: {
                    ...this.$route.query,
                    m: 'mobile',
                    openinbrowser: calendarUrl,
                    t: new Date().getTime(),
                },
            });
        },
        convertToPlain(html) {
            if (!html || typeof html !== 'string') {
                return '';
            }
            const tempDivElement = document.createElement('div');
            tempDivElement.innerHTML = html;
            return tempDivElement.textContent.trim() || tempDivElement.innerText.trim() || '';
        },
        openTicketURL() {
            window.open(normalizeUrlProtocol(this.event.FullURL), '_blank');
        },
        discardEventChanges() {
            this.getEvent();
        },
        selectType(type) {
            this.selectedType = type;
        },
        deriveEventFormatMode() {
            const hasLocation = Boolean(get(this.event, 'Location', '') || get(this.selectedLocation, 'Value', ''));
            const hasVideoLink = Boolean(get(this.event, 'ExternalLink', ''));

            if (hasLocation && hasVideoLink) {
                this.eventFormatMode = 'hybrid';
                return;
            }

            if (hasVideoLink) {
                this.eventFormatMode = 'online';
                return;
            }

            this.eventFormatMode = 'physical';
        },
        deriveTicketingMode() {
            const hasTickets = (this.event?.Tickets || []).some((ticket) => !ticket.Deleted);
            const hasExternalUrl = Boolean(get(this.event, 'FullURL', ''));

            if (hasTickets) {
                this.ticketingMode = 'internal';
                return;
            }

            if (hasExternalUrl) {
                this.ticketingMode = 'external';
                return;
            }

            this.ticketingMode = 'rsvp';
        },
        selectTicketingMode(mode) {
            if (this.hasExistingTickets && mode !== 'internal') {
                return;
            }

            this.ticketingMode = mode;
        },
        selectLocation(location) {
            this.selectedLocation = location;
        },
        tagsChanged(tags) {
            const tmp = uniq(tags);
            this.event.Tags = tmp;
        },
        removeOrganizer(id) {
            this.event.Organizers = this.event.Organizers.filter((o) => o !== id);
            this.participants = this.participants.filter((p) => p.ID !== id);
            this.updateEvent();
        },
        discardOrganizerCandidates() {
            this.coOrganizersCandidates = [];
        },
        saveOrganizerCandidates() {
            this.coOrganizersCandidates.forEach((candidate) => {
                // if candidate is already in organizers, skip
                if (this.event.Organizers && this.event.Organizers.includes(candidate.ID)) {
                    return;
                }

                if (!this.event.Organizers) {
                    this.event.Organizers = [];
                }
                this.event.Organizers.push(candidate.ID);

                if (!this.participants) {
                    this.participants = [];
                }

                this.participants.push(candidate);
            });

            // remove duplicates from participants by ID
            this.participants = uniqBy(this.participants, 'ID');

            // sort participants by role creator, organizer, participant
            this.participants = this.participants.sort((a, b) => {
                if (a.Role === 'creator') {
                    return -1;
                }
                if (b.Role === 'creator') {
                    return 1;
                }
                if (a.Role === 'organizer') {
                    return -1;
                }
                if (b.Role === 'organizer') {
                    return 1;
                }
                return 0;
            });

            this.updateEvent();
            this.coOrganizersCandidates = [];
        },
        searchUsers(query, source) {
            // search for users
            return new Promise((resolve, reject) => {
                // exit if query is less than 2 characters
                if (!query || query.length < 2) {
                    resolve([]);
                    return;
                }
                // fetch the search results
                axios({
                    method: 'GET',
                    url: `/search/user/${query}`,
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    cancelToken: source ? source.token : null,
                })
                    .then((response) => {
                        const results = get(response, 'data', []);
                        const mapped = results.map((el) => {
                            // if the user is not in the same space, show space thumbnail
                            let spaceIcon = null;
                            if (get(el, 'Space.ID', null) !== this.$store?.state?.space?.ID) {
                                spaceIcon = {
                                    imageURL: get(el, 'Space.FaviconURL', null),
                                    text: get(el, 'Space.Name', null),
                                    color: get(el, 'Space.PrimaryColor', null),
                                };
                            }
                            return {
                                thumbnailLabel: spaceIcon,
                                label: get(el, 'Profile.Name', ''),
                                thumbnail: get(el, 'Profile.ImageURL', ''),
                                disabled: false,
                                value: el,
                            };
                        });
                        resolve(mapped);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        removeCandidate(index) {
            this.coOrganizersCandidates.splice(index, 1);
        },
        selectOrganizerCandidate(user) {
            const u = get(user, 'value', null);
            if (!u) {
                return;
            }
            this.coOrganizersCandidates.push({
                ...u,
                Role: 'organizer',
            });
        },
        showParticipantsOnSeparatePage() {
            this.$router.push(`/events/${this.event.Slug}/participants`);
        },
        showParticipants() {
            this.$refs.participantsModal.show();
        },
        saveSection(section, index) {
            this.event.Sections[index] = section;
            this.sectionsRerenderKey += 1;
            this.updateEvent();
        },
        deleteSection(index) {
            if (!this.event.Sections) {
                this.sectionsRerenderKey += 1;
                return;
            }
            this.event.Sections.splice(index, 1);
            this.sectionsRerenderKey += 1;
            this.updateEvent();
        },
        moveSectionDown(index) {
            if (!this.event.Sections) {
                this.sectionsRerenderKey += 1;
                return;
            }
            const temp = this.event.Sections[index];
            this.event.Sections[index] = this.event.Sections[index + 1];
            this.event.Sections[index + 1] = temp;
            this.sectionsRerenderKey += 1;
            this.updateEvent();
        },
        moveSectionUp(index) {
            if (!this.event.Sections) {
                this.sectionsRerenderKey += 1;
                return;
            }
            const temp = this.event.Sections[index];
            this.event.Sections[index] = this.event.Sections[index - 1];
            this.event.Sections[index - 1] = temp;
            this.sectionsRerenderKey += 1;
            this.updateEvent();
        },
        addSection($event, index) {
            if (!Array.isArray(this.event.Sections)) {
                this.$set(this.event, 'Sections', []);
            }
            const insertIndex = typeof index === 'number' ? index + 1 : this.event.Sections.length;
            if ($event === 'text') {
                this.event.Sections.splice(insertIndex, 0, {
                    Type: 0,
                    Content: '',
                    StartEditMode: true,
                });
            } else if ($event === 'image') {
                this.event.Sections.splice(insertIndex, 0, {
                    Type: 1,
                    Images: [],
                    StartEditMode: true,
                });
            } else if ($event === 'video') {
                this.event.Sections.splice(insertIndex, 0, {
                    Type: 3,
                    Content: '',
                    StartEditMode: true,
                });
            } else if ($event === 'audio') {
                this.event.Sections.splice(insertIndex, 0, createAudioSection());
            } else if ($event === 'code') {
                this.event.Sections.splice(insertIndex, 0, {
                    Type: 2,
                    Content: '',
                    StartEditMode: true,
                });
            }
        },

        async fetchFeedAuthors(authorIDs: string[] = []) {
            if (authorIDs.length === 0) return [];

            try {
                const response = await axios({
                    method: 'POST',
                    url: '/user/listbyids',
                    data: { IDS: map(uniq(authorIDs), (id) => ({ ID: id })) },
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                return map(response.data.Users, (user) => ({
                    ID: get(user, 'ID'),
                    Name: get(user, 'Profile.Name'),
                    Slug: get(user, 'Slug'),
                    ImageURL: get(user, 'Profile.ImageURL'),
                    Bio: get(user, 'Profile.Bio'),
                }));
            } catch (error) {
                // eslint-disable-next-line no-console
                console.log(error);
                return [];
            }
        },
        applyFeedAuthors(users = []) {
            this.feed.forEach((entry, index) => {
                const currentEntry = this.feed[index];
                if (!currentEntry?.object) return;

                const authorID = currentEntry.object.AuthorID || currentEntry.object.CreatedBy;
                if (!authorID) return;

                const author = users.find((user) => user.ID === authorID);
                if (author) {
                    this.$set(currentEntry.object, 'Author', author);
                }
            });
        },
        parseEventDates() {
            const start = new Date(this.event.StartDate * 1000);
            this.startDate = start.toISOString().split('T')[0];
            this.startTime = format(start, 'HH:mm');

            const end = new Date(this.event.EndDate * 1000);
            this.endDate = end.toISOString().split('T')[0];
            this.endTime = format(end, 'HH:mm');
        },
        get,
        map,
        upperFirst,
        toLower,
        cloneDeep,
        async getEvent() {
            this.loadingEvent = true;
            try {
                this.pendingStreamPostIDs = [];
                const response = await axios.get(`/event/by-slug/${this.slug}`);
                this.event = response.data;
                this.normalizeEventLinks();

                if (get(this.event, 'Sections', []).length === 0 && this.event.Description) {
                    this.event.Sections = [
                        {
                            Type: 0,
                            Content: this.event.Description,
                        },
                    ];
                }

                this.getMyTicket();
                this.deriveTicketingMode();
                this.deriveEventFormatMode();

                this.parseEventDates();
                this.getParticipants();
                this.getEventTypes();
                this.getLocations();
                this.maybeHandleTicketPurchaseSuccess();
                // start ics download flow if downloadics param is set
                if (this.$route?.query?.downloadics) {
                    this.addToCalendar('ics');
                }
                const shouldShareInFeed = this.$route?.query?.toogleShareInFeed?.toString() === 'true';
                if (shouldShareInFeed) {
                    this.$nextTick(() => {
                        if (this.$refs.posteditor) {
                            this.setPrefilledContentForSharingInFeed();
                        }
                    });
                }
            } catch (error) {
                console.error(error);
                // Route missing event slugs to the dedicated event not-found page.
                if (get(error, 'response.status') === 404) {
                    this.$router.replace('/not-found/event');
                }
            }
            this.loadingEvent = false;
        },
        /**
         * Fetches the feed (updates) for the current page.
         */
        async getEventFeed() {
            if (!this.event?.ID) {
                return;
            }

            this.loadingUpdates = true;
            let url = `/event/feed/${this.event.ID}`;

            if (this.updatesNextPage) {
                url = this.updatesNextPage;
            }

            try {
                const response = await axios({
                    method: 'GET',
                    url,
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                let feedObjects =
                    get(response, 'data.objects', null) || (Array.isArray(response?.data) ? response.data : null) || [];

                this.updatesNextPage = get(response, 'data.next', null);

                if (!Array.isArray(feedObjects)) {
                    feedObjects = [];
                }

                let feedEntries = feedObjects.map((entry) => (get(entry, 'object') ? entry : { object: entry }));

                const fetchUsers = uniq(feedEntries.map((update) => get(update, 'object.AuthorID')).filter(Boolean));

                let users = [];
                if (fetchUsers.length > 0) {
                    try {
                        const usersResponse = await axios({
                            method: 'POST',
                            url: '/user/listbyids',
                            data: { IDS: map(fetchUsers, (id) => ({ ID: id })) },
                            withCredentials: true,
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        });

                        users = map(get(usersResponse, 'data.Users', []), (user) => ({
                            ID: get(user, 'ID'),
                            Name: get(user, 'Profile.Name'),
                            Slug: get(user, 'Slug'),
                            ImageURL: get(user, 'Profile.ImageURL'),
                            Bio: get(user, 'Profile.Bio'),
                        }));
                    } catch (error) {
                        console.log(error);
                    }
                }

                feedEntries = feedEntries.map((update) => {
                    if (!update.object) return update;

                    const authorId = get(update, 'object.AuthorID');

                    if (!update.object.Author && users && users.length) {
                        update.object.Author = users.find((user) => user.ID === authorId);
                    }

                    update.object.CreatedAt = update.object.CreatedAt || update.object.Created;
                    const images = get(update, 'object.Images', get(update, 'object.ImageURLs', []));
                    update.object.Images = map(images, (i) => (i?.ImageURL ? i : { ImageURL: i }));
                    if (!update.object.ParentID) {
                        update.object.ParentID = this.event.ID;
                    }
                    if (!update.object.ParentType) {
                        update.object.ParentType = 1;
                    }

                    return update;
                });

                this.feedBank = this.feedBank.concat(feedEntries);
                // this.feedBank.sort(
                //     (a, b) => Number(get(b, 'object.CreatedAt', 0)) - Number(get(a, 'object.CreatedAt', 0))
                // );

                // this.feedBank = this.feedBank.filter(
                //     (thing, index, self) =>
                //         index === self.findIndex(t => get(t, 'object.ID') === get(thing, 'object.ID'))
                // );

                // initially load the first batch of updates
                if (this.feed.length === 0 && this.feedBank.length > 0) {
                    if (this.feedBank.length > EVENT_FEED_VISIBLE_BATCH_SIZE) {
                        this.feed = this.feed.concat(this.feedBank.slice(0, EVENT_FEED_VISIBLE_BATCH_SIZE));
                        this.feedBank = this.feedBank.slice(EVENT_FEED_VISIBLE_BATCH_SIZE);
                    } else {
                        this.feed = this.feed.concat(this.feedBank);
                        this.feedBank = [];
                    }
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.loadingUpdates = false;
            }
        },
        addedPost(post = {}) {
            const postID = get(post, 'object.ID', '').toString();
            const existingIndex = (this.feed || []).findIndex(
                (feedEntry) => get(feedEntry, 'object.ID', '').toString() === postID
            );

            // The shared stream can deliver the post before CoPostEditor emits the create result.
            if (postID && existingIndex > -1) {
                this.feed.splice(existingIndex, 1, post);
                this.syncFeedOrder();
                return;
            }

            this.feedBank = this.feedBank.filter((entry) => get(entry, 'object.ID', '').toString() !== postID);
            if (this.feed && this.feed.length > 0) {
                this.feed.unshift(post);
            } else {
                // celebrate the first post with some confetti :)
                jsConfetti.addConfetti();
                this.feed = [post];
            }
        },
        deletedPost(post) {
            if (this.feed && this.feed.length > 0) {
                const index = this.feed.findIndex((p) => get(p, 'object.ID') === get(post, 'object.ID'));
                if (index > -1) {
                    this.feed.splice(index, 1);
                }
            } else {
                this.feed = [];
            }
            this.feedBank = this.feedBank.filter(
                (entry) => get(entry, 'object.ID', '').toString() !== get(post, 'object.ID', '').toString()
            );
            this.removePendingStreamPostID(get(post, 'object.ID'));
        },
        editPost(post = {}) {
            if (!post) return;
            // map post structure to editor structure
            const postToEdit = {
                ...get(post, 'object', {}),
                Files: map(get(post, 'object.Images', []), (i) => ({ url: i.ImageURL })),
                Type: 'post',
                wasUpdated: true,
            };
            this.$refs.posteditor.show(postToEdit, true);
        },
        editedPost(post = {}) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const that = this;
            if (post && this.feed) {
                // eslint-disable-next-line dot-notation
                post['wasUpdated'] = true;
                // find the post in the feed by id and update it
                const index = this.feed.findIndex((p) => get(p, 'object.ID') === get(post, 'object.ID'));
                if (index > -1) {
                    that.feed.splice(index, 1, post);
                }
            }
        },

        async loadFeedAuthors() {
            const authorIDs = this.feed
                .map((update) => update?.object?.AuthorID || update?.object?.CreatedBy)
                .filter(Boolean);
            const users = await this.fetchFeedAuthors(authorIDs);
            this.applyFeedAuthors(users);
        },

        scroll() {
            window.onscroll = () => {
                const feedContainer = this.$refs['feed-container'];
                if (!feedContainer) return;

                // get the distance from the bottom of the page to the bottom of the feed container
                const distanceFromBottom = feedContainer.getBoundingClientRect().bottom - window.innerHeight;

                const percentage = (distanceFromBottom * 100) / feedContainer.clientHeight;

                if (percentage < 10) {
                    if (this.feedBank.length !== 0 && this.feedBank.length > 3) {
                        this.feed = this.feed.concat(this.feedBank.slice(0, 3));
                        this.feedBank = this.feedBank.slice(3);
                    } else if (this.feedBank.length !== 0 && this.feedBank.length <= 3) {
                        this.feed = this.feed.concat(this.feedBank);
                        this.feedBank = [];
                    } else if (this.updatesNextPage && !this.loadingUpdates) {
                        this.getEventFeed();
                    }
                }
            };
        },

        openTicketCheckout() {
            if (this.isEventPast) {
                return;
            }
            const ticketscheckout = this.$refs.ticketscheckout as any;
            if (ticketscheckout) {
                ticketscheckout.openModal();
            }
        },
        attendEvent() {
            this.loadingParticipants = true;
            const request = {
                EventID: this.event.ID,
                ParticipantID: this.me.ID,
            };
            axios({
                method: 'POST',
                url: '/event/participant',
                data: request,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.event = response.data;
                        this.getParticipants();
                    }
                })
                .catch((error) => {
                    console.error(error);
                    EventBus.$emit('ERROR', {
                        Message: this.$t('labels.failedGeneric'),
                        Details: error,
                    });
                })
                .finally(() => {
                    this.loadingParticipants = false;
                });
        },
        unattendEvent() {
            this.loadingParticipants = true;
            const request = {
                EventID: this.event.ID,
                ParticipantID: this.me.ID,
            };
            axios({
                method: 'DELETE',
                url: '/event/participant',
                data: request,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.event = response.data;
                        this.getParticipants().then(() => {
                            if (!this.amIattending) {
                                this.feed = [];
                            }
                        });
                    }
                })
                .catch((error) => {
                    console.error(error);
                    EventBus.$emit('ERROR', {
                        Message: this.$t('labels.failedGeneric'),
                        Details: error,
                    });
                })
                .finally(() => {
                    this.loadingParticipants = false;
                });
        },
        showAllAttachments() {
            if (this.$refs.attachmentsModal) {
                this.$refs.attachmentsModal.show();
            }
        },
        triggerAttachmentPicker() {
            const input = this.$refs.eventAttachmentInput as HTMLInputElement | undefined;
            if (input) {
                input.value = '';
                input.click();
            }
        },
        onAttachmentInputChange(event) {
            const files = get(event, 'target.files');
            if (!files || files.length === 0) return;
            Array.from(files).forEach((file) => {
                this.addPendingAttachment(file);
            });
        },
        addPendingAttachment(file: File) {
            if (!file) return;
            const extension = file.name.includes('.') ? file.name.split('.').pop() : '';
            const normalized = normalizeAttachmentFile({
                Name: file.name,
                file_name: file.name,
                Size: file.size,
                size: file.size,
                format: extension || file.type || '',
                Extension: extension || file.type || '',
                blob: file,
                URL: URL.createObjectURL(file),
                CreatedAt: Math.floor(Date.now() / 1000),
            });
            this.pendingEventAttachments.push({
                ...normalized,
                __tempID: `upload-${this.attachmentUploadCounter + 1}`,
            });
            this.attachmentUploadCounter += 1;
        },
        attachmentUploaded(data: any, index: number) {
            if (!data || !data.url) return;
            const pending = this.pendingEventAttachments[index];
            if (!pending) return;
            const normalized = normalizeAttachmentFile({
                ...pending,
                URL: data.url,
                url: data.url,
                Name: data.file_name || pending.Name,
                file_name: data.file_name || pending.file_name,
                Size: data.size ?? pending.Size,
                size: data.size ?? pending.size,
                format: data.format || pending.format,
                Extension: data.format || pending.Extension,
            });
            this.pendingEventAttachments.splice(index, 1);
            if (!Array.isArray(this.event.Attachments)) {
                this.$set(this.event, 'Attachments', []);
            }
            this.event.Attachments.push(normalized);
            this.updateEvent();
        },
        removePendingAttachment(index: number) {
            if (index < 0 || index >= this.pendingEventAttachments.length) return;
            this.pendingEventAttachments.splice(index, 1);
        },
        removeAttachment(index: number) {
            if (!Array.isArray(this.event.Attachments)) return;
            this.event.Attachments.splice(index, 1);
            this.updateEvent();

            if (!this.event.Attachments || this.event.Attachments.length === 0) {
                this.$refs.attachmentsModal.hide();
            }
        },
        removeImage() {
            this.newImage = null;
            this.event.ImageURL = null;
            this.event.Images = [];
            this.updateEvent();
        },
        publishEventAsPublic() {
            this.event.Visibility = 1;
            this.event.Draft = false;
            this.updateEvent();
        },

        publishEventAsCommunityOnly() {
            this.event.Visibility = 0;
            this.event.Draft = false;
            this.updateEvent();
        },
        draftEvent() {
            this.event.Draft = true;
            this.event.Visibility = 0;
            this.updateEvent();
        },
        headerImageInput(image) {
            if (image && image.filePreview) {
                this.newImage = image.filePreview;
                this.newImageUploading = true;
                if (!this.$store) {
                    console.error('Store not available');
                    this.newImageUploading = false;
                    return;
                }
                this.$store
                    .dispatch('imageUpload', {
                        file: image.file,
                        url: '/upload/image/events',
                    })
                    .then((response) => {
                        this.event.ImageURL = response;
                        this.event.Images = [response];
                        this.updateEvent();
                    })
                    .catch((error) => {
                        console.log(error);
                        const errorMsg = {
                            Message: this.$t('messages.imageUploadError'),
                            Details: '',
                        };
                        if (
                            error.response &&
                            error.response.data &&
                            error.response.data.message === 'Request Entity Too Large'
                        ) {
                            errorMsg.Message = this.$t('messages.imageUploadSizeError');
                        }
                        EventBus.$emit('ERROR', errorMsg);
                    })
                    .finally(() => {
                        this.newImageUploading = false;
                        this.newImage = null;
                    });
            }
        },

        isValidLink(value) {
            return isValidExternalUrl(value);
        },
        normalizeEventLinks() {
            // Keep editable event links in a canonical format before persisting or opening them.
            this.event.FullURL = normalizeUrlProtocol(this.event.FullURL);
            this.event.ExternalLink = normalizeUrlProtocol(this.event.ExternalLink);
        },
        updateEvent() {
            this.loadingEvent = true;
            if (!this.$store) {
                console.error('Store not available');
                this.loadingEvent = false;
                return;
            }

            this.normalizeEventLinks();

            if (
                (this.eventFormatMode === 'online' || this.eventFormatMode === 'hybrid') &&
                !this.isValidLink(this.event.ExternalLink)
            ) {
                const message = {
                    Message: this.$t('messages.linkmustbevalidurl'),
                };
                EventBus.$emit('ERROR', message);
                this.loadingEvent = false;
                return;
            }

            if (this.selectedType) {
                this.event.EventType = [this.selectedType.Value];
            }

            const start = new Date(`${this.startDate}T${this.startTime}`);
            const end = new Date(`${this.endDate}T${this.endTime}`);
            // convert to unix timestamp
            this.event.StartDate = start.getTime();
            this.event.EndDate = end.getTime();

            // devide by 1000 to get seconds and round to integer and covert to string
            this.event.StartDate = Math.round(this.event.StartDate / 1000).toString();
            this.event.EndDate = Math.round(this.event.EndDate / 1000).toString();

            if (this.eventFormatMode === 'physical' || this.eventFormatMode === 'hybrid') {
                if (get(this.selectedLocation, 'Value', '') === 'custom') {
                    this.event.Location = '';
                    if (this.customLocation.Name) {
                        this.event.Location += `${this.customLocation.Name}`;
                    }
                    if (this.customLocation.Address) {
                        this.event.Location += `${this.event.Location ? ', ' : ''}${this.customLocation.Address}`;
                    }
                    if (this.customLocation.ZipCode) {
                        this.event.Location += `${this.event.Location ? ', ' : ''}${this.customLocation.ZipCode}`;
                    }
                    if (this.customLocation.City) {
                        if (this.customLocation.ZipCode) {
                            this.event.Location += ` `;
                        } else {
                            this.event.Location += `, `;
                        }
                        this.event.Location += `${this.customLocation.City}`;
                    }
                    if (this.customLocation.Country) {
                        this.event.Location += `${this.event.Location ? ', ' : ''}${this.customLocation.Country}`;
                    }
                } else if (this.selectedLocation && this.selectedLocation.Name) {
                    this.event.Location = this.selectedLocation.Name;
                } else {
                    this.event.Location = '';
                }
            } else {
                this.event.Location = '';
            }

            if (this.hasExistingTickets) {
                this.ticketingMode = 'internal';
            }

            if (this.ticketingMode === 'rsvp') {
                this.event.Tickets = [];
                this.event.FullURL = '';
                this.event.TicketingMode = 1;
            } else if (this.ticketingMode === 'external') {
                this.event.Tickets = null;
                this.event.TicketingMode = 2;
            } else {
                this.event.FullURL = '';
                this.event.TicketingMode = 3;
            }

            if (this.eventFormatMode === 'physical') {
                this.event.ExternalLink = '';
            } else if (this.eventFormatMode === 'online') {
                this.event.Location = '';
            }
            // combine all sections into description field for backward compatibility
            this.event.Description = '';
            if (this.event.Sections && this.event.Sections.length > 0) {
                this.event.Sections.forEach((section) => {
                    // if image section then add images as html img tags
                    if (section.Type === 1) {
                        section.Images.forEach((img) => {
                            this.event.Description += `<img style="width: 100%;" src="${img}" alt="event image" />\n<br>`;
                        });
                    } else {
                        this.event.Description += section.Content;
                        this.event.Description += '\n<br>';
                    }
                });
            } else {
                this.event.Description = '';
            }
            this.$store
                .dispatch('updateEvent', this.event)
                .then((response) => {
                    if (this.toToogleShareInFeed) {
                        this.toToogleShareInFeed = false;
                        // if event is published and was not shared in feed before, share it now
                        this.setPrefilledContentForSharingInFeed();
                    }
                    const message = {
                        Message: this.$t('labels.changessaved'),
                        Details: '',
                    };
                    EventBus.$emit('INFO', message);
                    this.loadingEvent = false;
                    this.deriveTicketingMode();
                    this.deriveEventFormatMode();
                    this.parseEventDates();
                    this.getParticipants();
                    this.getEventTypes();
                    this.getLocations();
                })
                .catch((error) => {
                    const message = {
                        Message: this.$t('labels.failedToSaveChanges'),
                        Details: error,
                    };
                    EventBus.$emit('ERROR', message);
                    this.loadingEvent = false;
                });
        },

        getEventTypes() {
            axios
                .get('/event/type/list')
                .then((response) => {
                    if (response && response.data && response.data.objects) {
                        this.types = response.data.objects.map((type) => ({
                            Name: type.Value,
                            Value: type.Slug,
                            Disabled: false,
                        }));
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {});
        },

        getLocations() {
            this.locations = [];

            axios
                .get('/booking/locations')
                .then((response) => {
                    if (response?.data?.Locations) {
                        this.locations = response.data.Locations;
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {});
        },

        getUserRoleInEvent(id) {
            if (this.event.CreatedBy === id) {
                return 'creator';
            }
            if (this.event.Organizers && this.event.Organizers.includes(id)) {
                return 'organizer';
            }
            return 'participant';
        },

        async getParticipants() {
            this.loadingParticipants = true;

            try {
                const users = await axios({
                    method: 'POST',
                    url: '/user/listbyids',
                    data: { IDS: map(uniq(this.allParticipants), (id) => ({ ID: id })) },
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                this.participants = map(users.data.Users, (user) => ({
                    ID: get(user, 'ID'),
                    Name: get(user, 'Profile.Name'),
                    FirstName: get(user, 'Profile.FirstName'),
                    LastName: get(user, 'Profile.LastName'),
                    Slug: get(user, 'Slug'),
                    ImageURL: get(user, 'Profile.ImageURL'),
                    Bio: get(user, 'Profile.Bio'),
                    Role: this.getUserRoleInEvent(get(user, 'ID')),
                    Score: get(user, 'Score', 0),
                    Status: get(user, 'Status'),
                }));

                // sort participants by role creator, organizer, participant
                this.participants = this.participants.sort((a, b) => {
                    if (a.Role === 'creator') {
                        return -1;
                    }
                    if (b.Role === 'creator') {
                        return 1;
                    }
                    if (a.Role === 'organizer') {
                        return -1;
                    }
                    if (b.Role === 'organizer') {
                        return 1;
                    }
                    return 0;
                });

                // find createdBy user
                this.createdBy = this.participants.find((p) => p.ID === this.event.CreatedBy);
                this.loadingParticipants = false;
            } catch (error) {
                console.log(error);
                this.loadingParticipants = false;
            }
        },

        deleteEvent() {
            this.loadingEvent = true;

            axios({
                url: `/event`,
                method: 'DELETE',
                data: this.event,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(() => {
                    this.$router.push('/events');
                    EventBus.$emit('INFO', {
                        Message: this.$t('messages.eventdeleted'),
                        Details: '',
                    });
                })
                .catch((error) => {
                    console.error(error);
                    this.loadingEvent = false;

                    EventBus.$emit('ERROR', {
                        Message: this.$t('labels.failedGeneric'),
                        Details: error,
                    });
                });
        },
        getTaxRates() {
            this.loadingTaxRate = true;
            axios({
                method: 'GET',
                url: `/space/tax/list`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.taxRates = response.data;
                    }
                    this.loadingTaxRate = false;
                })
                .catch((error) => {
                    this.loadingTaxRate = false;
                    console.log(error);
                });
        },
        createDuplicate() {
            if (!this.event) {
                console.error('Event not loaded');
                return;
            }
            const obj = cloneDeep(this.event);
            // remove fields that should not be duplicated
            delete obj['Slug'];
            delete obj['Participants'];
            delete obj['ParticipantsCount'];
            delete obj['FullURL']; // remove deprecated field full url which was used to link to external ticketing systems

            this.$store.state.eventDuplicate = obj;
            this.$router.push('/event/create');
        },
    },
};
